import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, redirect: String }

  connect() {
    this.poll()
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  poll() {
    fetch(this.urlValue, {
      headers: { "Accept": "text/html" }
    }).then(response => {
      if (response.redirected) {
        Turbo.visit(response.url, { action: "replace" })
      } else {
        this.timeout = setTimeout(() => this.poll(), 500)
      }
    }).catch(() => {
      this.timeout = setTimeout(() => this.poll(), 500)
    })
  }
}
